import { createSlice } from '@reduxjs/toolkit';

import { fetchBankAccounts, updateBankAccount } from './thunks';
import { BankAccount } from './types';

const initialState = {
  bankAccounts: [] as BankAccount[],
  isLoading: false,
  showActionSuccessToast: false,
  actionSuccessToastText: null,
};

const payrollBankAccountsSlice = createSlice({
  name: 'payrollBankAccounts',
  initialState,
  reducers: {
    removeBankAccount: (state, action) => {
      state.bankAccounts = state.bankAccounts.filter(
        bankAccount => bankAccount.id !== action.payload
      );
    },
    showActionToast: (state, { payload }) => {
      state.showActionSuccessToast = true;
      state.actionSuccessToastText = payload;
    },
    hideActionToast: state => {
      state.showActionSuccessToast = false;
      state.actionSuccessToastText = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBankAccounts.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchBankAccounts.fulfilled, (state, action) => {
        state.bankAccounts = action.payload.sort(
          (a: BankAccount, b: BankAccount) => +b.default - +a.default
        );
        state.isLoading = false;
      })
      .addCase(fetchBankAccounts.rejected, state => {
        state.isLoading = false;
      })
      .addCase(updateBankAccount.fulfilled, (state, action) => {
        state.bankAccounts = state.bankAccounts.map(bankAccount =>
          bankAccount.id === action.payload.id ? action.payload : bankAccount
        );
      });
  },
});

export const { removeBankAccount, showActionToast, hideActionToast } =
  payrollBankAccountsSlice.actions;
export default payrollBankAccountsSlice.reducer;
